export default {
    props: {
        templatesTemplateType: {
            type: String,
            default: undefined,
            kComposite: 'templates.template.type'
        }, 
        templatesTemplateTemplate: {
            type: String,
            default: undefined,
            kComposite: 'templates.template.template'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoNotification/Templates.js